import { go, sel } from 'fxjs/es';
import { $qs } from 'fxdom/es';
import { getCurrentFcanvas } from '../../Fcanvas/cv_object.js';
import { makeCanvasTextured } from '../../cylinder.js';
import { loadImageFromUrl, makeCanvasByContrastEffect, makeCanvasByUrl } from '../../../../Canvas/S/util.js';
import { NewMakerCheckerF } from '../../../../NewMaker/Checker/F/Function/module/NewMakerCheckerF.js';
import { deepFindCvObjectsAsync } from '../../util.js';
import { CanvasF } from '../../../../Canvas/F/Function/module/CanvasF.js';

export const isShadeBp = function (base_product) {
  return go(
    base_product,
    sel('_.base_product_colors.0._.base_product_color_faces.0._.base_product_face'),
    isShadeStyle,
  );
};

export const isShadeStyle = function (fcanvas_or_size_face) {
  return !!sel('preview.shade', fcanvas_or_size_face);
};

export const isShadeStyle2 = function (fcanvas_or_size_face) {
  return !!sel('preview.shade2', fcanvas_or_size_face);
};

export const isBlackAndWhiteContrast = function (fcanvas_or_size_face) {
  return !!sel('preview.shade.is_black_and_white_contrast', fcanvas_or_size_face);
};

export const isShadeBpNotBlackAndWhiteContrast = function (base_product) {
  return go(
    base_product,
    sel('_.base_product_colors.0._.base_product_color_faces.0._.base_product_face'),
    (obj) => isShadeStyle(obj) && !isBlackAndWhiteContrast(obj),
  );
};

export const isFcanvasShadeMode = (fcanvas) => {
  return isShadeStyle(fcanvas) || isShadeStyle2(fcanvas) || isBlackAndWhiteContrast(fcanvas);
};

export const getShadeFcanvas = (fcanvas) => {
  if (!($qs('html.maker_page') || G.mp.maker.is_activated)) return;
  fcanvas = fcanvas || getCurrentFcanvas();
  return isShadeStyle(fcanvas) && fcanvas;
};
function invertImage(img) {
  return new Promise((resolve, reject) => {
    if (!(img instanceof HTMLImageElement)) {
      reject(new Error('Input must be an HTMLImageElement'));
      return;
    }

    const width = img.naturalWidth || img.width;
    const height = img.naturalHeight || img.height;

    if (!width || !height) {
      reject(new Error('Invalid image dimensions'));
      return;
    }

    // OffscreenCanvas 지원 여부 확인
    const canvas =
      'OffscreenCanvas' in window ? new OffscreenCanvas(width, height) : document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(img, 0, 0, width, height);
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0) {
        // 투명도가 0이 아닐 때만 반전
        data[i] = 255 - data[i]; // R
        data[i + 1] = 255 - data[i + 1]; // G
        data[i + 2] = 255 - data[i + 2]; // B
      }
    }

    ctx.putImageData(imageData, 0, 0);

    const invertedImg = new Image();
    invertedImg.onload = () => resolve(invertedImg);
    invertedImg.onerror = reject;
    invertedImg.src = canvas.toDataURL();
  });
}
export async function renderMakerPageShade(fcanvas, cv_object) {
  if (!fcanvas) return;
  if (fcanvas.is_preview_pass) return;
  if (sel('preview.shade', fcanvas)) {
    const is_black_and_white_contrast = sel('preview.shade.is_black_and_white_contrast', fcanvas);
    const hex = sel('preview.shade.hex', fcanvas);
    await G.mp.maker.cv_objects_deep_each(cv_object, async (cv_o) => {
      if (cv_o._data.is_not_design) return;
      if (is_black_and_white_contrast) {
        if (hex) cv_o._data.shade_default_hex = hex;
        cv_o._data.is_black_and_white_contrast = true;
        if (cv_o._data.cv_type === 'cv_image') {
          cv_o._element = await go(
            makeCanvasByContrastEffect(
              await makeCanvasByUrl(G.to_600(cv_o._data.image_url)),
              cv_o._data.shade_default_hex,
            ),
            (c) => c.toDataURL(),
            loadImageFromUrl,
          );
          if (cv_o._data.is_inverted_image) {
            cv_o._element = await CanvasF.invertImage(cv_o._element);
          }
        } else {
          if (!hex) return;
          cv_o._element = await go(
            makeCanvasTextured(cv_o._element, hex, null),
            (c) => c.toDataURL(),
            loadImageFromUrl,
          );
        }
      } else {
        delete cv_o._data.is_black_and_white_contrast;
        delete cv_o._data.shade_default_hex;
        if (!hex) return;
        cv_o._element = await go(
          makeCanvasTextured(cv_o._element, hex, null),
          (c) => c.toDataURL(),
          loadImageFromUrl,
        );
      }
    });
  }
}

export async function hasFullImageCvImage(objects) {
  return deepFindCvObjectsAsync(objects, async (cv_obj) => {
    if (cv_obj._data.cv_type === 'cv_image') {
      const img_canvas = await makeCanvasByUrl(G.to_150(cv_obj._data.image_url));
      return NewMakerCheckerF.isFullImage(img_canvas);
    }
  });
}
